<template>
  <div>
    <h4>Installation events in last 30 days</h4>
    <ResponsiveTable
        :items="installationLog"
        :fields="installationLogFields"
        :searchable_fields="installationLogSearchableFields"
        sort-by="time"
        sort-direction="desc"
    >
        <template v-slot:cell(product_serial_num)="row">
          <b-icon icon="circle-fill" :variant="row.item.online ? 'success' : 'danger'"/>
          &nbsp
          <router-link :to="{ name: 'DevicePage', params: { serial: row.item.device_serial }}">{{ row.item.product_serial_num }}</router-link>
        </template>
        <template v-slot:cell(circuit)="row">
          <router-link :to="{ name: 'DashboardPage' }">
            <span @click="setSelectedDevice(row.item.product_serial_num)">
                {{row.item.circuit}}
            </span>
          </router-link>
        </template>
      <template v-slot:cell(time)="row">
        {{ datetimeFormatter(row.item.time) }} (<timeago :datetime=row.item.time></timeago>)
      </template>
    </ResponsiveTable>
  </div>
</template>

<script>
import datetimeFormatter from '@/core/datetimeFormatterHelper';
import { deviceService } from "@/_services";
import { mapActions } from 'vuex';
import ResponsiveTable from '@/components/ResponsiveTable/ResponsiveTable'

export default {
  name: 'InstallationLog',
  components: {ResponsiveTable},
  data() {
    return {
      installationLog: [],
      installationLogFields: [{
          key: 'product_serial_num',
          label: 'SERIAL',
          class: 'productSerialNum',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'type',
          label: 'Type',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'circuit',
          label: 'CIRCUIT',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'pole_substation_name',
          label: 'SUBSTATION NAME',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'time',
          label: 'TIME',
          sortable: true,
          sortDirection: 'asc',
          formatter: datetimeFormatter
        }
      ],
      installationLogSearchableFields: [
          "product_serial_num",
          "type",
          "pole_substation_name",
          "circuit",
      ]
    };
  },
  methods: {
    ...mapActions('alert', ['error']),
    ...mapActions("dashboard", ["setSelectedDevice",]),
    updateinstallationLog() {
      deviceService.getInstallationLog()
      .then(response => {
        this.installationLog = response.data.installation_log
      })
      .catch(() => {
        this.error('Error getting Installation log');
      });
    },
    datetimeFormatter(date) {
      return datetimeFormatter(date);
    }
  },
  mounted() {
    this.updateinstallationLog();
  }
}

</script>
